<template>
  <div
    v-if="!labelInsideTextarea"
    class="custom-textarea"
  >
    <label v-if="label">
      {{ label }}
    </label>

    <textarea
      :value="value"
      :placeholder="placeholder"
      :disabled="disabled"
      @input="event => $emit('update', event.target.value)"
    />
  </div>

  <div v-else>
    <md-field :class="['input', { 'md-invalid': errors.length || hasExceededMaxLength }]">
      <label v-if="label">
        {{ label }}
      </label>

      <md-textarea
        :value="value"
        :placeholder="placeholder"
        :disabled="disabled"
        v-bind="inputProps"
        @input="onChange"
      />
      <template v-if="errors.length">
        <span
          v-for="(error, index) in errors"
          :key="index"
          class="md-error"
        >
          {{ $t(`errors.${error}`) }}
        </span>
      </template>
    </md-field>
    <div
      v-if="maxLength"
      class="counter flex justify-end"
      :class="{ 'counter--error': hasExceededMaxLength }"
    >
      {{ value.length }} / {{ maxLength }}
    </div>
  </div>
</template>

<script>
  export default {
    name: 'XTextarea',
    model: {
      prop: 'value',
      event: 'update'
    },
    props: {
      labelInsideTextarea: {
        type: Boolean,
        default: true
      },
      inputProps: {
        type: Object,
        default: () => ({})
      },
      value: {
        type: [String, Number]
      },
      label: {
        type: String,
        default: null
      },
      placeholder: {
        type: String,
        default: null
      },
      errors: {
        type: Array,
        default: () => []
      },
      disabled: {
        type: Boolean,
        default: false
      },
      maxLength: {
        type: Number,
        default: null
      }
    },

    computed: {
      hasExceededMaxLength () {
        return this.maxLength && this.value.toString().length > this.maxLength
      }
    },

    methods: {
      onChange (value) {
        this.$emit('update', value)
      }
    }
  }
</script>


<style lang='scss' scoped rel='stylesheet/scss'>
  @import '~@/styles/vars.scss';

  .custom-textarea {
    label {
      display: block;
      color: $color-galaxy;
      font-size: 1.4rem;
      margin-left: $space-medium;
      margin-bottom: $space-small;
      font-weight: 600;
    }

    textarea {
      width: 100%;
      max-width: 100%;
      padding: $space-medium;
      border: 0.1rem solid $color-ghost;
      border-radius: 0.2rem;
      font-size: 1.4rem;
      font-family: inherit;

      &:focus {
        outline-color: map_get($palette-primary, main);
      }

      &::placeholder {
        color: #DBDCDF;
        font-size: 1.3rem;
      }
    }
  }

  .counter {
    position: relative;
    top: -12px;

    &--error {
      color: $color-error;
    }
  }
</style>